export default __webpack_public_path__ + "static/media/logo_circuito_360.a9413262.svg";